import { useEffect, useState } from "react";

const InputWrapper = (p) => {

    return (
        <div className="CollectionInputBar_input">
            <label>
                <span>{p.label}</span>
                {p.children}
            </label>
        </div>
    );
};

export default InputWrapper;